import { Action, ActionCreator } from 'redux';
import { VideoWatchHistoryInterface } from './watch-history';

export const READ = 'READ';
export interface READAction extends Action {
    watchHistory: Array<VideoWatchHistoryInterface>;
}
export const read = (watchHistory) => ({
    type: READ,
    watchHistory: watchHistory
});

export const CLEAR = 'CLEAR';
export interface CLEARAction extends Action {
    watchHistory: Array<VideoWatchHistoryInterface>;
}
export const clear = (watchHistory) => ({
    type: CLEAR,
});
